import React, { useState, useRef } from 'react'
import { Validaciones } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import ListAltIcon from '@material-ui/icons/ListAlt';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';
import { rgxNumeros } from '../../../helpers/regexp';

import * as Permisos from '../Permisos';

const { trim } = Validaciones;

// Longitud de la columna NOMBRE y valor maximo de ORDEN (TINYINT) en las tablas de tipos
const maxNombre = 50;
const maxOrden = 127;

// Catalogo comun para los tipos de seguimiento de seguros y de siniestros;
// cada uno le pasa sus consultas y el titulo de la pantalla
function CatalogoTiposSeguimiento({ titulo, asyncGet, asyncTabla, asyncAdd, asyncUpdate, asyncDelete }) {

    const { token } = useSelector(state => state.login);

    const cleanState = {
        tipoSeguimientoID: null,
        nombre: "",
        orden: ""
    };
    const cleanErrorState = {
        nombre: { error: false, helperText: "" },
        orden: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);

    let titleAccion = state.tipoSeguimientoID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Tipo de Seguimiento`;

    const nombreRef = useRef(null);
    const ordenRef = useRef(null);

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "tipoSeguimientoID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert, asyncGet,
            // El orden llega como numero; el campo del formulario es texto
            formatearResultado: [{ id: "orden", formato: (orden) => orden === null || orden === undefined ? "" : String(orden) }]
        })
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "tipoSeguimientoID" }, { campo: "nombre" }],
        disabled: { multiseleccion: true },
        onClick: ({ tipoSeguimientoID, nombre }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el tipo de seguimiento ${nombre}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { tipoSeguimientoID }, asyncDelete
            })
        })
    }];

    let botones = [
        {
            accionID: [2],
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        }, {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }];

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "tipoSeguimientoID",
        color: primary,
        title: titulo,
        iconTable: <ListAltIcon />,
        headers: [
            { variable: "tipoSeguimientoID", descripcion: "TipoSeguimientoID", hide: true },
            { variable: "nombre", descripcion: "Tipo de Seguimiento" },
            { variable: "orden", descripcion: "Orden" }
        ],
        responsiveTitle: ["nombre"],
        filter: [
            { campo: "nombre" }
        ],
        alineacion: [{ columnas: [0, 1], alineacion: "left" }, { columnas: [2], alineacion: "center" }]
    }

    const inputs = [
        {
            id: "Arriba",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: [
                {
                    disabled,
                    id: "nombre",
                    value: state.nombre,
                    error: errorState.nombre.error,
                    success: state.nombre && !errorState.nombre.error ? true : undefined,
                    helperText: errorState.nombre.helperText,
                    inputRef: nombreRef,
                    title: "Tipo de Seguimiento *",
                    placeholder: "Capture el nombre del tipo de seguimiento",
                    grid: { md: 9, lg: 9 },
                    onChange: ({ target: { value } }) => handleChange(value.toUpperCase(), "nombre"),
                    onKeyDown: () => { return; }
                },
                {
                    disabled,
                    id: "orden",
                    value: state.orden,
                    error: errorState.orden.error,
                    success: state.orden && !errorState.orden.error ? true : undefined,
                    helperText: errorState.orden.helperText,
                    inputRef: ordenRef,
                    title: "Orden",
                    placeholder: "Posición en los listados",
                    grid: { md: 3, lg: 3 },
                    onChange: ({ target: { value } }) => handleChange(value.replace(/[^0-9]/g, ""), "orden"),
                    onKeyDown: () => { return; }
                }
            ]
        }
    ];

    let accionesFormulario = [{
        accionID: state.tipoSeguimientoID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: nombreRef,
            mensajeCorrecto: `El tipo de seguimiento se ${state.tipoSeguimientoID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ nombre, orden }) {

        let error;
        let validaciones = [
            {
                condicion: !nombre || trim(nombre) === "",
                ref: nombreRef, keyError: "nombre",
                mensajeError: "Debe especificar el nombre del tipo de seguimiento"
            },
            {
                condicion: trim(nombre).length > maxNombre,
                ref: nombreRef, keyError: "nombre",
                mensajeError: `El nombre no debe exceder de ${maxNombre} caracteres`
            },
            {
                condicion: orden !== "" && (!rgxNumeros.test(orden) || Number(orden) > maxOrden),
                ref: ordenRef, keyError: "orden",
                mensajeError: `El orden debe ser un número entre 0 y ${maxOrden}`
            }
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let { tipoSeguimientoID, nombre, orden } = state;
            orden = orden === null || orden === undefined ? "" : String(orden);

            let error = await handleValidaciones({ nombre, orden });

            if (error) return error;

            let input = { nombre: trim(nombre), orden: orden === "" ? null : Number(orden) };

            if (tipoSeguimientoID) await asyncUpdate({ input: { tipoSeguimientoID, ...input } }, token);
            else await asyncAdd({ input }, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={asyncTabla}
            token={token}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={nombreRef}
        />
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default CatalogoTiposSeguimiento;
